const mq = window.matchMedia('(min-width: 992px)')

export default mq
